import { useState } from 'react';
import { HardDrive } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { usePersonnalisation } from '../hooks/usePersonnalisation';
import ModaleEspace from './ModaleEspace';

/**
 * L'alerte d'espace saturé, sous le logo.
 *
 * Elle vit à côté du décompte de gratuité, en badge de danger : un espace
 * plein bloque tout dépôt de pièce, et l'apprendre au moment d'envoyer un
 * justificatif est trop tard. Le badge est un bouton — un clic ouvre
 * l'extension, sans passer par une page qu'il faudrait aller chercher.
 *
 * Il ne regarde que les membres : un visiteur n'a pas à savoir ce que
 * l'association occupe.
 */
export default function BadgeEspace({ className = '' }: { className?: string }) {
  const perso = usePersonnalisation();
  const { user } = useAuth();
  const [ouverte, setOuverte] = useState(false);

  const espace = (perso as any)?.espace;
  if (!user || !espace) return null;

  // Sous le seuil d'alerte, rien : un badge permanent finit par ne plus se
  // voir, et celui-ci doit se voir le jour où il paraît.
  if (!espace.sature && !espace.alerte) return null;

  const sature = espace.sature === true;

  return (
    <>
      <button
        onClick={() => setOuverte(true)}
        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[0.7rem] font-semibold whitespace-nowrap transition ${
          sature
            ? 'bg-red-100 text-red-800 hover:bg-red-200 dark:bg-red-900/40 dark:text-red-200'
            : 'bg-amber-100 text-amber-800 hover:bg-amber-200 dark:bg-amber-900/40 dark:text-amber-200'
        } ${className}`}
        title={
          sature
            ? 'Espace saturé : plus aucun document ne peut être déposé. Cliquez pour étendre.'
            : `Espace occupé à ${espace.part} %. Cliquez pour étendre.`
        }
      >
        <HardDrive className="w-3 h-3 shrink-0" aria-hidden="true" />
        {sature ? 'Espace saturé' : `Espace ${espace.part} %`}
      </button>

      <ModaleEspace ouverte={ouverte} onFermer={() => setOuverte(false)} />
    </>
  );
}
